import script from "./MeetingQuestionReviewPc.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingQuestionReviewPc.vue?vue&type=script&setup=true&lang=ts"

import "./MeetingQuestionReviewPc.vue?vue&type=style&index=0&id=006311fd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-006311fd"]])

export default __exports__